/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Labs_Predictor_SubtitleInputs */

const en_ui_labs_predictor_subtitle = /** @type {(inputs: Ui_Labs_Predictor_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Predict race times from a recent result using VDOT`)
};

const de_ui_labs_predictor_subtitle = /** @type {(inputs: Ui_Labs_Predictor_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prognostiziere Rennzeiten anhand eines aktuellen Ergebnisses per VDOT`)
};

/**
* | output |
* | --- |
* | "Predict race times from a recent result using VDOT" |
*
* @param {Ui_Labs_Predictor_SubtitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_labs_predictor_subtitle = /** @type {((inputs?: Ui_Labs_Predictor_SubtitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Labs_Predictor_SubtitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_labs_predictor_subtitle(inputs)
	return de_ui_labs_predictor_subtitle(inputs)
});